<template>
    <div id="panel">
      <img :src="img" alt="">
      <div id="btn" @click="onClick"></div>
    </div>
</template>

<script>
  import _$ from 'jquery'

  export default {
    name: 'Panel',
    props: {
      imgsrc: String
    },
    data() {
      return {
        img: null
      }
    },
    mounted() {
        this.updateImg()
    },
    watch: {
      imgsrc(newValue) {
        if(newValue){
          _$('#panel img').show()
          this.img = newValue
        } else {
          _$('#panel img').hide()
          this.img = null
        }

        if(newValue.indexOf('story5_04.png') > -1){
          _$('#btn').show()
        } else {
          _$('#btn').hide()
        }
      }

    },
    methods: {
      updateImg(){
        this.img = this.$parent.imgSrc
      },
      onClick: function(){
        this.$emit('btnTap', 9);
      }
    }
  }
</script>

<style lang="scss" scoped>
  #panel {  
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  #btn {
    width: toVW(453);
    height: toVW(201);
    position: absolute;
    top: calc(50% - 35.46vw);
    left: toVW(58);
    display: none;
  }
</style>